import { certsFormattedMessage, getMessageKey } from '../../../utils/utils';
import { ACTION_BUTTON_KINDS, CHECKBOX_CONSTANTS } from '../constant';

export const enableReassignPopover = (config) => {
  if (config.enableReassignUser === '1' || config.showReassignPopup === '1') {
    return true;
  }

  return false;
};

export const enablePredefinedCommentReassign = (config) => {
  if (config.enableReassignUser === '1') {
    return true;
  }

  return false;
};

export const checkReassignWithComments = (config) => {
  if (config.enableReassignUser === '0' && config.showReassignPopup === '0') {
    return true;
  }

  return false;
};

export const showConsultPopover = () => {
  const consultPopoverFlag = localStorage.getItem(CHECKBOX_CONSTANTS.CONSULT);

  if (
    consultPopoverFlag === null ||
    consultPopoverFlag === undefined ||
    consultPopoverFlag === 'true'
  ) {
    return true;
  }

  return false;
};

export const showConsultWarnModal = () => {
  const consultWarnFlag = localStorage.getItem(CHECKBOX_CONSTANTS.CONSULT_WARN);

  if (
    consultWarnFlag === null ||
    consultWarnFlag === undefined ||
    consultWarnFlag === 'true'
  ) {
    return true;
  }

  return false;
};

export const getWarnModalText = (
  messages,
  localize,
  intl,
  kind,
  consultantInfo,
  count
) => {
  let warnText = certsFormattedMessage(
    messages.CERTS_CONSULT_WARN_MESSAGE ||
      localize(intl, getMessageKey('CERTS_CONSULT_WARN_MESSAGE')),
    {
      userinfo: consultantInfo || 'First Last (username)',
    }
  );

  if (kind !== ACTION_BUTTON_KINDS.CONSULT) {
    if (count && count > 1) {
      warnText = certsFormattedMessage(
        messages.CERTS_CONSULT_OTHER_ACTIONS_WARN_MESSAGE ||
          localize(
            intl,
            getMessageKey('CERTS_CONSULT_OTHER_ACTIONS_WARN_MESSAGE')
          ),
        {
          count: count || 0,
        }
      );
    }
  } else if (kind === ACTION_BUTTON_KINDS.CONSULT) {
    if (count && count > 1) {
      warnText = certsFormattedMessage(
        messages.CERTS_CONSULT_ACTION_WARN_MESSAGE ||
          localize(intl, getMessageKey('CERTS_CONSULT_ACTION_WARN_MESSAGE')),
        {
          count: count || 0,
        }
      );
    } else {
      warnText = certsFormattedMessage(
        messages.CERTS_CONSULT_DEFAULT_WARN_MESSAGE ||
          localize(intl, getMessageKey('CERTS_CONSULT_DEFAULT_WARN_MESSAGE')),
        {
          userinfo: consultantInfo || 'First Last (username)',
        }
      );
    }
  }

  return warnText;
};

export const getBtnText = (messages, localize, intl, kind) => {
  let btnText =
    messages.CERTS_CONSULT_MAKE_DECISION ||
    localize(intl, getMessageKey('CERTS_CONSULT_MAKE_DECISION'));

  if (kind === ACTION_BUTTON_KINDS.CONSULT) {
    btnText =
      messages.CERTS_CONSULT_NEW_REQUEST ||
      localize(intl, getMessageKey('CERTS_CONSULT_NEW_REQUEST'));
  }

  return btnText;
};

export const getWarnModalTitle = (messages, localize, intl, count) => {
  let title =
    messages.CERTS_CONSULTATION_IS_PENDING ||
    localize(intl, getMessageKey('CERTS_CONSULTATION_IS_PENDING'));

  if (count > 1) {
    title =
      messages.CERTS_CONSULTATIONS_ARE_PENDING ||
      localize(intl, getMessageKey('CERTS_CONSULTATIONS_ARE_PENDING'));
  }

  return title;
};
